import { makeStyles } from '@mui/styles';

export const useProjectSummaryContentStyles = makeStyles((theme) => ({
  root: {
    padding: '102px 32px 32px 32px',
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  }
}));
